// Autogenerated file
export const userStatesEnum = {
    Valid: "Valid",
    Banned: "Banned",
    Invited: "Invited",
};
export const userStates = [
    { label: "Член организации", value: "Valid" },
    { label: "Забанен", value: "Banned" },
    { label: "Приглашён", value: "Invited" },
];
